
<app-detail-card
  [isLoading]="isLoading"
  [title]="getCardTitle()"
  [image]="equipmentImage"
  [backLevels]="2"
  [canUploadImage]="mode != getModes().NEW"
  [contentToShow]="mode == getModes().NEW ? DetailCardContent.EMPTY : DetailCardContent.TABS"
  [tabs]="[
      { name: 'Procedures', content: proceduresTab },
      { name: 'Resources', content: resourcesTab },
      { name: 'Physical assets', content: physicalAssetsTab }
    ]"
  (onUploadImageClick)="uploadImage()"
>


  <!-- General information -->
  <div class="form" sidebar-content>

    <div class="group-title">{{ 'General information' | translate }}</div>
    <div class="group">

      <!-- Brand -->
      <mat-form-field>
        <mat-label>{{ 'Brand' | translate }}</mat-label>
        <input matInput [(ngModel)]="equipment.manufacturer" required>
      </mat-form-field>
      <br>

      <!-- Model -->
      <mat-form-field>
        <mat-label>{{ 'Model' | translate }}</mat-label>
        <input matInput [(ngModel)]="equipment.name" required>
      </mat-form-field>
      <br>

      <!-- Description -->
      <mat-form-field>
        <mat-label>{{ 'Description' | translate }}</mat-label>
        <textarea matInput [(ngModel)]="equipment.description" [rows]="15" required></textarea>
      </mat-form-field>
      <br>

      <!-- Child of -->
      <!--<mat-form-field>
        <mat-label>Child of (optional)</mat-label>
        <mat-select>
          <mat-option>No parent</mat-option>
          <mat-option value="option">Test asset 1</mat-option>
        </mat-select>
      </mat-form-field>-->

    </div>

  </div>


  <!-- Sidebar actions -->
  <ng-container sidebar-actions>
    <button *ngIf="mode == getModes().NEW" mat-raised-button color="primary" (click)="save()" [disabled]="!equipment.validateModel()">{{ 'Create equipment' | translate }}</button>
    <button *ngIf="mode == getModes().UPDATE" mat-raised-button color="primary" (click)="save()" [disabled]="!equipment.validate()">{{ 'Save equipment' | translate }}</button>
    <button *ngIf="mode == getModes().UPDATE" mat-raised-button color="warn" (click)="delete()" [disabled]="!equipment.validate()">{{ 'Remove equipment' | translate }}</button>
  </ng-container>

  <!-- Empty statement on new item -->
  <ng-container empty-statement>
    {{ 'Create an equipment to start adding resources, procedures and physical assets' | translate }}
  </ng-container>


  <!-- Procedures -->
  <ng-template #proceduresTab>

    <!-- Header -->
    <div class="header">

      <!-- Search bar -->
      <app-search-bar *ngIf="!environment.production" placeholder="Search procedure..." (textSubmit)="filterProcedures($event)"></app-search-bar>

      <div class="spacer"></div>

      <!-- Actions -->
      <div class="actions">
        <button mat-stroked-button color="primary" (click)="newProcedure()">
          <mat-icon>add</mat-icon> {{ 'New procedure' | translate }}
        </button>
      </div>

    </div>

    <!-- Procedure list -->
    <div class="procedures">
      <app-authoring-slot *ngFor="let procedure of equipment.procedures"
                          [title]="procedure.name"
                          [task]="procedure.tasksTotal"
                          [procedureTypes]="procedure.types"
                          [canDelete]="procedure.isErasable"
                          (onEdit)="updateProcedure(procedure)"
                          (onRemove)="removeProcedure(procedure.id)"
                          (click)="router.navigate(['authoring/' + procedure.id], { relativeTo: this.route })"
      ></app-authoring-slot>
      <!-- TODO DEPRECATED -->
      <!--<app-authoring-slot isEmpty="true" (click)="router.navigate(['authoring'], { relativeTo: this.route })"></app-authoring-slot>-->
    </div>
    <span *ngIf="!equipment.procedures || equipment.procedures.length == 0" class="no-item">{{ 'No procedure found' | translate }}</span>

    <div class="spacer"></div>

    <!-- Procedure paginator -->
    <mat-paginator
      [hidePageSize]="true"
      [pageSize]="paginatorProcedure.pageSize"
      [pageIndex]="paginatorProcedure.currentPage"
      [length]="paginatorProcedure.totalElements"
      (page)="paginatorProcedure.pageChanged($event)"
      showFirstLastButtons>
    </mat-paginator>

  </ng-template>


  <!-- Resources -->
  <ng-template #resourcesTab>

    <!-- Resource grid -->
    <app-media-grid
      [equipment]="equipment"
      [cols]="6"
      [resources]="resources"
      [paginator]="paginatorResources"
      [uploadableResources]="ResourceUtils.allResources"
      [viewableResources]="ResourceUtils.allResources"
      [editable]="true"
    ></app-media-grid>

  </ng-template>


  <!-- Physical assets -->
  <ng-template #physicalAssetsTab>

    <div class="header">

      <!-- Search bar -->
      <app-search-bar placeholder="Search physical asset..." (textSubmit)="filterPhysicalAssets($event)"></app-search-bar>

      <div class="spacer"></div>

      <!-- Actions -->
      <div class="actions">
        <button mat-stroked-button color="primary" (click)="router.navigate(['asset'], { relativeTo: route })">
          <mat-icon>add</mat-icon> {{ 'New asset' | translate }}
        </button>
        <button mat-stroked-button color="primary" (click)="importAssets()">
          <mat-icon>archive</mat-icon> {{ 'Import assets' | translate }}
        </button>
        <button mat-stroked-button color="primary" (click)="downloadQRCodes()">
          <mat-icon>qr_code</mat-icon> {{ 'Download QR codes' | translate }}
        </button>
      </div>

    </div>

    <!-- Physical assets table -->
    <app-table
      [columns]="getPhysicalAssetsTableColumns()"
      [rows]="getPhysicalAssetsTableData()"
      [paginator]="paginatorPhysicalAssets"
      (onItemClicked)="showPhysicalAsset($event)"
    ></app-table>

  </ng-template>


</app-detail-card>

<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
